import { string, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { password } from '../../../utils/validation.js';
import { a as INCORRECT_EMAIL_MESSAGE, E as EMAIL_REQUIRED_MESSAGE, h as CAPTCHA_REQUIRED_MESSAGE } from '../../../validation-g1IuPS7K.js';

const getInitialValues = (email) => ({
    email,
    password: '',
});

const getValidationSchema = (captcha = false) => {
    const validationSchema = {
        email: string().nullable().email(INCORRECT_EMAIL_MESSAGE).required(EMAIL_REQUIRED_MESSAGE),
        password,
        ...(captcha && {
            captcha: string().required(CAPTCHA_REQUIRED_MESSAGE),
        }),
    };
    return yupResolver(object().shape(validationSchema));
};

export { getInitialValues, getValidationSchema };
//# sourceMappingURL=index.js.map
